export const data=[
    {
        imgSrc:require('../../assets/pieSimple.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
        
const App = () => {
    const data = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return <PieChart data={data}/>;
};`
    },
    // 2
    {
        imgSrc:require('../../assets/labeledPie.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
        
const App = () => {
    const pieData = [
        {value: 54, color: '#177AD5', text: '54%'},
        {value: 40, color: '#79D2DE', text: '30%'},
        {value: 20, color: '#ED6665', text: '26%'},
    ];
    
    return(
        <View>
            <PieChart
            showText
            textColor="black"
            radius={150}
            textSize={20}
            showTextBackground
            textBackgroundRadius={26}
            data={pieData}
            />
    </View>
    )
};`
    },
    // 3
    {
        imgSrc:require('../../assets/split.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
        
    const App = () => {
        const pieData = [
            {value: 54, color: '#177AD5'},
            {value: 40, color: '#79D2DE'},
            {value: 20, color: '#ED6665', shiftX: 28, shiftY: -18}
        ];
        return <PieChart data={pieData}/>;
    )
}`
    },
    // 4
    {
        imgSrc:require('../../assets/donut3d.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
        
const App = () => {
    const pieData = [
        {value: 54, color: '#177AD5', text: '54%'},
        {value: 40, color: '#79D2DE', text: '30%'},
        {value: 20, color: '#ED6665', text: '26%'},
    ];
    
    return(
        <View>
            <PieChart
            donut
            isThreeD
            showText
            textColor="black"
            radius={170}
            textSize={20}
            showTextBackground
            textBackgroundRadius={26}
            data={pieData}
            />
    </View>
    )
};`
    },
    // 5
    {
        imgSrc:require('../../assets/donut3dreal.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
        
const App = () => {
    const pieData = [
        {value: 54, color: '#177AD5', text: '54%'},
        {value: 40, color: '#79D2DE', text: '30%'},
        {value: 20, color: '#ED6665', text: '26%'},
    ];
    
    return(
        <View>
            <PieChart
            donut
            isThreeD
            showText
            innerCircleBorderWidth={6}
            innerCircleBorderColor="lightgray"
            textColor="black"
            radius={170}
            textSize={20}
            showTextBackground
            textBackgroundRadius={26}
            data={pieData}
            />
    </View>
    )
};`},
// 6
{
    imgSrc:require('../../assets/donut3dshifted.png'),
    code:`import { PieChart } from "react-native-gifted-charts";
    
const App = () => {
const pieData = [
    {value: 54, color: '#177AD5', text: '54%'},
    {value: 40, color: '#79D2DE', text: '30%'},
    {value: 20, color: '#ED6665', text: '26%'},
    ];

    return(
        <View>
            <PieChart
            donut
            isThreeD
            showText
            innerCircleBorderWidth={6}
            innerCircleBorderColor="lightgray"
            shiftInnerCenterX={-10}
            shiftInnerCenterY={-15}
            textColor="black"
            radius={170}
            textSize={20}
            showTextBackground
            textBackgroundRadius={26}
            data={pieData}
            />
        </View>
    )
};`},
//7
{
  imgSrc:require('../../assets/pieGrad.png'),
  code:`import { PieChart } from "react-native-gifted-charts";
    
const App = () => {
  const pieData = [
      {value: 54, color: '#177AD5'},
      {value: 40, color: '#79D2DE'},
      {value: 20, color: '#ED6665'}
  ];
  return <PieChart data={pieData} showGradient/>;
)
}`
},
//8
{
  imgSrc:require('../../assets/donutGrad.png'),
  code:`import { PieChart } from "react-native-gifted-charts";
    
const App = () => {
  const pieData = [
      {value: 54, color: '#177AD5'},
      {value: 40, color: '#79D2DE'},
      {value: 20, color: '#ED6665'}
  ];
  return (
    <PieChart
      data={pieData}
      radius={150}
      donut
      showText
      showValuesAsLabels
      showTextBackground
      textBackgroundColor="#333"
      textBackgroundRadius={22}
      textColor="white"
      textSize={16}
      fontWeight="bold"
      strokeWidth={10}
      strokeColor="#333"
      innerCircleBorderWidth={10}
      innerCircleBorderColor="#333"
      showGradient
    />
  );
}`
},
    // 9
    {
        imgSrc:require('../../assets/battery.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
    
const App = () => {
    const pieData = [
        {value: 70, color: '#177AD5'},
        {value: 30, color: 'lightgray'}
    ];
    return(
        <View>
            <PieChart
                donut
                innerRadius={80}
                data={pieData}
                centerLabelComponent={() => {
                return <Text style={{fontSize: 30}}>70%</Text>;
                }}
            />
        </View>
    );
}`
    },
    // 10
    {
        imgSrc:require('../../assets/legendPie.png'),
        code:`import { PieChart } from "react-native-gifted-charts";
const App = () => {
    const renderLegend = (text, color) => {
        return (
          <View style={{flexDirection: 'row', marginBottom: 12}}>
            <View
              style={{
                height: 18,
                width: 18,
                marginRight: 10,
                borderRadius: 4,
                backgroundColor: color || 'white',
              }}
            />
            <Text style={{color: 'white', fontSize: 16}}>{text || ''}</Text>
          </View>
        );
      };
    
      return (
        <View>
          <View
            style={{
              marginVertical: 100,
              marginHorizontal: 30,
              borderRadius: 10,
              paddingVertical: 50,
              backgroundColor: '#414141',
              justifyContent: 'center',
              alignItems: 'center',
            }}>


            {/*********************    Custom Header component      ********************/}
            <Text
              style={{
                color: 'white',
                fontSize: 32,
                fontWeight: 'bold',
                marginBottom: 12,
              }}>
              Quarterly Sales
            </Text>
            {/****************************************************************************/}


            <PieChart
              strokeColor="white"
              strokeWidth={4}
              donut
              data={[
                {value: 30, color: 'rgb(84,219,234)'},
                {value: 40, color: 'lightgreen'},
                {value: 20, color: 'orange'},
              ]}
              innerCircleColor="#414141"
              innerCircleBorderWidth={4}
              innerCircleBorderColor={'white'}
              showValuesAsLabels={true}
              showText
              textSize={18}
              showTextBackground={true}
              centerLabelComponent={() => {
                return (
                  <View>
                    <Text style={{color: 'white', fontSize: 36}}>90</Text>
                    <Text style={{color: 'white', fontSize: 18}}>Total</Text>
                  </View>
                );
              }}
            />


            {/*********************    Custom Legend component      ********************/}
            <View
              style={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                marginTop: 20,
              }}>
              {renderLegend('Jan', 'rgb(84,219,234)')}
              {renderLegend('Feb', 'lightgreen')}
              {renderLegend('Mar', 'orange')}
            </View>
            {/****************************************************************************/}

            
          </View>
        </View>
    );
}`
    }
];

export const customGradientPie = `import { PieChart } from "react-native-gifted-charts";
const App = () => {
  const pieData = [
    {value: 54, color: '#177AD5', gradientCenterColor: 'lightblue'},
    {value: 40, color: '#79D2DE', gradientCenterColor: '#7777cc'},
    {value: 20, color: '#ED6665', gradientCenterColor: 'pink'},
  ];
  return <PieChart data={pieData} showGradient/>;
}`

export const focusPie = `import { PieChart } from "react-native-gifted-charts";
const App = () => {
  const pieData = [
    {value: 54, color: '#177AD5'},
    {value: 40, color: '#79D2DE'},
    {value: 20, color: '#ED6665'},
  ];
  
  return(
    <PieChart
      data={pieData}
      showText
      textColor="black"
      radius={150}
      textSize={20}
      focusOnPress
      showValuesAsLabels
      showTextBackground
      textBackgroundRadius={26}
    />
  );
}`

export const focusPieSectionsData = `const pieData = [
  {value: 54, color: '#177AD5'},
  {value: 40, color: '#79D2DE'},
  {value: 20, color: '#ED6665'},
];

return(
  <PieChart
    data={pieData}
    showText
    textColor="black"
    radius={150}
    textSize={20}
    focusOnPress
    showValuesAsLabels
    showTextBackground
    textBackgroundRadius={26}
  />
);`

export const sectionAutoFocusPie = `import { PieChart } from "react-native-gifted-charts";

const App = () => {
  const pieData = [
  {
    value: 47,
    color: '#009FFF',
    gradientCenterColor: '#006DFF',
    focused: true,
  },
  {value: 40, color: '#93FCF8', gradientCenterColor: '#3BE9DE'},
  {value: 16, color: '#BDB2FA', gradientCenterColor: '#8F80F3'},
  {value: 3, color: '#FFA5BA', gradientCenterColor: '#FF7F97'},
];

const renderDot = color => {
  return (
    <View
      style={{
        height: 10,
        width: 10,
        borderRadius: 5,
        backgroundColor: color,
        marginRight: 10,
      }}
    />
  );
};

const renderLegendComponent = () => {
  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          marginBottom: 10,
        }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            width: 120,
            marginRight: 20,
          }}>
          {renderDot('#006DFF')}
          <Text style={{color: 'white'}}>Excellent: 47%</Text>
        </View>
        <View
          style={{flexDirection: 'row', alignItems: 'center', width: 120}}>
          {renderDot('#8F80F3')}
          <Text style={{color: 'white'}}>Okay: 16%</Text>
        </View>
      </View>
      <View style={{flexDirection: 'row', justifyContent: 'center'}}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            width: 120,
            marginRight: 20,
          }}>
          {renderDot('#3BE9DE')}
          <Text style={{color: 'white'}}>Good: 40%</Text>
        </View>
        <View
          style={{flexDirection: 'row', alignItems: 'center', width: 120}}>
          {renderDot('#FF7F97')}
          <Text style={{color: 'white'}}>Poor: 3%</Text>
        </View>
      </View>
    </>
  );
};

return (
  <View
    style={{
      paddingVertical: 100,
      backgroundColor: '#34448B',
      flex: 1,
    }}>
    <View
      style={{
        margin: 20,
        padding: 16,
        borderRadius: 20,
        backgroundColor: '#232B5D',
      }}>
      <Text style={{color: 'white', fontSize: 16, fontWeight: 'bold'}}>
        Performance
      </Text>
      <View style={{padding: 20, alignItems: 'center'}}>
        <PieChart
          data={pieData}
          donut
          showGradient
          sectionAutoFocus
          radius={90}
          innerRadius={60}
          innerCircleColor={'#232B5D'}
          centerLabelComponent={() => {
            return (
              <View style={{justifyContent: 'center', alignItems: 'center'}}>
                <Text
                  style={{fontSize: 22, color: 'white', fontWeight: 'bold'}}>
                  47%
                </Text>
                <Text style={{fontSize: 14, color: 'white'}}>Excellent</Text>
              </View>
            );
          }}
        />
      </View>
      {renderLegendComponent()}
    </View>
  </View>);
}`